export default "__VITE_ASSET__DcFO3A9c__"